import React, { useEffect, useState } from "react";
import Retool from "react-retool";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import { FlexContainer } from "../Dashboard/styled";
import adminApis from "../../../apis/admin";
import DashboardSkeleton from "../Dashboard/DashboardSkeleton";
import { RootState } from "../../../redux/store";

interface RetoolEmbedProps {
  retoolPage: string;
}

const RetoolEmbed = ({ retoolPage }: RetoolEmbedProps) => {
  const [retoolEmbedUrl, setRetoolEmbedUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const { user: loggedInUser } = useSelector(
    (state: RootState) => state.profile
  );

  useEffect(() => {
    if (isEmpty(retoolPage)) {
      setRetoolEmbedUrl("");
      return;
    }
    setLoading(true);
    adminApis
      .getRetoolEmbedUrl(retoolPage)
      .then((data: any) => {
        if (!data || !data.embedUrl) {
          console.error("Invalid API response: Missing embedUrl");
          setRetoolEmbedUrl("");
          return;
        }
        setRetoolEmbedUrl(data.embedUrl);
      })
      .catch((error) => {
        console.error("Error fetching Retool URL:", error);
        setRetoolEmbedUrl("");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [retoolPage]);

  return (
    <>
      {loading || isEmpty(retoolEmbedUrl) ? (
        <DashboardSkeleton loading={loading} />
      ) : (
        <FlexContainer>
          <Retool url={retoolEmbedUrl} data={{ email: loggedInUser.email }} />
        </FlexContainer>
      )}
    </>
  );
};

export default RetoolEmbed;
